module.exports = __webpack_public_path__ + "img/4.03d507c2.jpg";